import React from 'react';
import FormHelper from '../../../components/FormBuilder/FormHelpers';
import {FieldLabel} from '../FieldLabel'
import { DivRichTextView } from '../../Common/RichTextView';

const InputExplanatoryText = ({renderField ,field, isFormWizard, openFieldLabelModal, currentLocale}) => {
  if(!renderField){
    return null
  }

  let parentAttributes = {
    'tooltip': field.tooltip
  }

  let labelAttributes = FormHelper.setLabelStyle(field, isFormWizard, parentAttributes);

  return (
  	<div className="form-group col-xs-12" {...parentAttributes}>
      <div className="flex coldir m-b-20">
    	  <FieldLabel field={field} 
          isFormWizard={isFormWizard}
          labelAttributes={labelAttributes} 
          currentLocale={currentLocale}
          openFieldLabelModal={openFieldLabelModal}/>
        <DivRichTextView className="br-grey p-5 bg-white" 
          html={(field.locale?.description_text?.[currentLocale] || field.description_text)} />
 	    </div>
    </div> 
  )
}

export default InputExplanatoryText;